import { createSelector } from 'reselect';
import { RootState, UserState } from '../model/state';

/**
 * Direct selector to the state
 */
const selectUser = () => (state: RootState) => state.user;

/**
 * Other specific selectors
 */
const selectUserList = () => createSelector(
  selectUser(),
  (user: UserState) => user.list
);

const selectCurrentUser = () => createSelector(
  selectUser(),
  (user: UserState) => user.current.data
);

const selectCurrentIsLoading = () => createSelector(
  selectUser(),
  (user: UserState) => user.current.isLoading
);

const selectUserSearch = () => createSelector(
  selectUser(),
  (user: UserState) => user.search
);

export default selectUser;
export {
  selectUserList,
  selectCurrentUser,
  selectCurrentIsLoading,
  selectUserSearch,
}
